// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"horizontal--TaKiwT7X"};